import { SlotItem } from './slotItem';
import { ElementMenuItem } from './elementMenuItem';
import Element, { SpecyficType, ElementType } from './element';
import { placementManager } from '@/models/placementManager';
import { Vector2 } from '@babylonjs/core';
import { stringUtil } from './stringUtil';

class SlotsManager {
    private body!: Element;

    public initialize(body: Element) {
        this.body = body;
    }

    public createSlots(
        element: ElementMenuItem,
        without: (x: Element) => boolean = () => false,
    ): SlotItem[] {
        if (element.specyficType === SpecyficType.SHELF) {
            const offsetY = 0.5 * element.shape.y;
            return this._createSlots(element, offsetY, 0.5, (e, s) => this.createShelfAvatar(e, s), without);
        } else {
            const offsetY = 0.5 * (element.shape.y - 1);
            return this._createSlots(element, offsetY, 1, (e, s) => this.createAvatar(e, s), without);
        }
    }

    private _createSlots(
        element: ElementMenuItem,
        offsetY: number,
        jIncrement: number,
        createAvatar: (e: ElementMenuItem, s: SlotItem) => string,
        without: (x: Element) => boolean = () => false,
    ): SlotItem[] {
        const result: SlotItem[] = [];
        const offsetX = 0.5 * (element.shape.x - 1);
        for (let i = 1 + offsetX; i <= this.body.shape.x - offsetX; i++) {
            for (let j = 1 + offsetY; j <= this.body.shape.y - offsetY; j += jIncrement) {
                if (this.isNotAllowed(element, i, j)) { continue; }
                const position = new Vector2(i, j);
                if (placementManager.canPlace(position, element.shape, element.type, element.specyficType, without)) {
                    const slot = new SlotItem('', position, element.shape);
                    const avatar = createAvatar(element, slot);
                    slot.url = avatar;
                    result.push(slot);
                }
            }
        }
        return result;
    }

    private isNotAllowed(element: ElementMenuItem, i: number, j: number): boolean {
        if (element.specyficType === SpecyficType.DRAWER && j > 2) {
            // ograniczenie wysokościowe szuflad
            return true;
        }
        return false;
    }

    private createShelfAvatar(element: ElementMenuItem, slot: SlotItem): string {
        const bs = this.body.shape;
        const es = element.shape;
        const pos = stringUtil.toShelfPosition('?', slot);
        return `${bs.x}x${bs.y}_${pos}_${es.x}x0.5.png`;
    }

    private createAvatar(element: ElementMenuItem, slot: SlotItem): string {
        const bs = this.body.shape;
        const es = element.shape;
        const pos = stringUtil.toFrontPosition('?', slot);
        return `${bs.x}x${bs.y}_${pos}_${es.x}x${es.y}.png`;
    }
}

export const slotsManager = new SlotsManager();
